import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TableInsertColumn = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 28 28"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.75a.75.75 0 0 0-1.5 0v20.5a.75.75 0 0 0 1.5 0V3.75Zm20.5 0a.75.75 0 0 0-1.5 0v20.5a.75.75 0 0 0 1.5 0V3.75ZM11.75 3A2.75 2.75 0 0 0 9 5.75v16.5A2.75 2.75 0 0 0 11.75 25h4.5A2.75 2.75 0 0 0 19 22.25V5.75A2.75 2.75 0 0 0 16.25 3h-4.5ZM10.5 5.75c0-.69.56-1.25 1.25-1.25h4.5c.69 0 1.25.56 1.25 1.25V10h-7V5.75Zm0 5.75h7v5h-7v-5Zm0 6.5h7v4.25c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25V18Z"
  }));
});
TableInsertColumn.displayName = 'TableInsertColumn';
export var TableInsertColumnDimensions = {
  height: 28,
  width: 28
};